
function winOpenWParams(url, params) {
	if (window.focus()) {
		self.focus();
	}
	window.open(url,"new",params);
}


function winOpen(url) {
	if (window.focus()) {
		self.focus();
	}
	window.open(url,"new","resizable=no,toolbar=no,location=no,width=460,height=750,directories=no,status=yes,scroll=no,scrollbars=no,menubar=no");
}


function winOpen360(url) {
	if (window.focus()) {
			self.focus();
		}
	window.open(url,"new","resizable=no,toolbar=no,location=no,width=450,height=688,directories=no,status=yes,scroll=no,scrollbars=no,menubar=no");
}

function winOpenFlight(url) {
	if (window.focus()) {
			self.focus();
		}
	window.open(url,"new","resizable=no,toolbar=no,location=no,width=500,height=500,directories=no,status=yes,scroll=yes,scrollbars=yes,menubar=no");
}

function winOpenDiagram(url) {
	if (window.focus()) {
			self.focus();
		}
	window.open(url,"new","resizable=yes,toolbar=no,location=no,width=650,height=625,directories=no,status=yes,scroll=no,scrollbars=no,menubar=no");
}

function winOpenBridgeCam(url) {
	if (window.focus()) {
			self.focus();
		}
	window.open(url,"_blank","resizable=yes,toolbar=no,location=no,width=650,height=460,directories=no,status=yes,scroll=no,scrollbars=no,menubar=no");
}

function winOpenVideo(url) {
	var w, h, popW = 740/*671*/, popH = 600/*583*/;
	
	w = screen.availWidth;
	h = screen.availHeight;
	
	var leftPos = (w-popW)/2, topPos = 0;
	
	if (window.focus()) {
			self.focus();
	}

	window.open(url,"_blank","resizable=yes,toolbar=no,location=yes,width=" + popW +" ,height=" + popH+",top=" + topPos +" ,directories=no,status=yes,scroll=no,scrollbars=no,menubar=no");
}
function showpano(vtid){
	var settings='width=360,height=520,top=5,left=5,scrollbars=no,location=no,directories=no,status=no,menubar=no,toolbar=no,resizable=yes'
	var win=window.open('http://delivery.vrxstudios.com/princess/vrxviewer.asp?id=' + vtid,'vrxviewer',settings);
	win.focus();
}

function showpanotwo(vtid){
	var settings='width=360,height=520,top=5,left=5,scrollbars=no,location=no,directories=no,status=no,menubar=no,toolbar=no,resizable=yes'
	var win=window.open('http://delivery.vrxstudios.com/50385/virtualtours.htm?id=' + vtid + '&id_type=2','vrxviewer',settings);
	win.focus();
}

$(document).ready(function(){
	 $(".winPopUp").on('click', function(event){
     winOpenVideo($(".winPopUp").attr('href'));
	 event.preventDefault();
	});
});

function selfOpenFromFlash(_url, _value, _gtStr)
{
	var url;
	
	if(_url != null || _url != "")
		url = eval(_url);
	else
		url = "";

	if (_value != null || _value != ""){
		url = (url+_value);
	}
	
	if(_gtStr != null || _gtStr != "")
		pageTracker._trackPageview(_gtStr);
		
	document.location.href = url;
}